import EmblaCarousel from 'embla-carousel';

document.querySelectorAll('.wp-block-blueprint-testimonials').forEach((block) => {
	const viewport = block.querySelector('.testimonials__list');
	const prevButton = block.querySelector('.testimonials__button--prev');
	const nextButton = block.querySelector('.testimonials__button--next');
	const dotsContainer = block.querySelector('.testimonials__dots');

	if (!viewport) {
		return;
	}

	const embla = EmblaCarousel(viewport, {
		loop: true,
		align: 'start',
		containScroll: 'trimSnaps',
	});

	if (prevButton) {
		prevButton.addEventListener('click', () => embla.scrollPrev());
	}

	if (nextButton) {
		nextButton.addEventListener('click', () => embla.scrollNext());
	}

	if (!dotsContainer) {
		return;
	}

	const dots = embla.scrollSnapList().map((_, index) => {
		const button = document.createElement('button');

		button.className = 'testimonials__dot';
		button.type = 'button';
		button.setAttribute('aria-label', `Go to testimonial ${index + 1}`);

		button.addEventListener('click', () => {
			embla.scrollTo(index);
		});

		dotsContainer.appendChild(button);

		return button;
	});

	const updateDots = () => {
		const selectedIndex = embla.selectedScrollSnap();

		dots.forEach((dot, index) => {
			const isSelected = index === selectedIndex;

			dot.classList.toggle('is-active', isSelected);
			dot.setAttribute('aria-current', isSelected ? 'true' : 'false');
		});
	};

	embla.on('select', updateDots);
	embla.on('reInit', updateDots);

	updateDots();
});